import { createContext, useContext } from "react";
import { useCartHook } from "./useCart";

const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const cart = useCartHook();

  return (
    <CartContext.Provider value={cart}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => {
  return useContext(CartContext);
};